<template>
  <div>
    <vue-base64-file-upload
      v-if="
          elementTypeQuestion != 'select' && elementTypeQuestion != 'orderedChoices'
      "
      class="upload_wrapper_answer"
      accept="image/png, image/jpeg"
      image-class="upload_imagepreview"
      input-class="upload_imageinput"
      :disable-preview="true"
      :max-size="customImageMaxSize"
      @size-exceeded="onSizeExceeded"
      @file="onFile"
      @load="onLoad"
    />
  </div>
</template>

<script>
import VueBase64FileUpload from 'vue-base64-file-upload'
export default {
  name: 'ButtonImageAnswer',
  props: [
    'indexQuestion',
    'indexAnswer',
    'answer',
    'allFoldingQuestion',
    'elementTypeQuestion',
    'indexSection'
  ],
  components: {
    VueBase64FileUpload
  },
  data () {
    return {
      customImageMaxSize: 4
    }
  },
  methods: {
    onSizeExceeded (size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      )
    },
    onFile (file) {},
    onLoad (dataUri) {
      this.$store.commit('ADD_IMG_ANSWER', {
        dataUri: dataUri,
        answer: this.answer,
        indexSection: this.indexSection,
        indexQuestion: this.indexQuestion,
        indexAnswer: this.indexAnswer
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/components/ButtonImageAnswer.vue